import Route from '../route';

$(function () {
    if (Route === "cookies") {
        function handleConsentSwitch(consentType) {
            const $switchInput = $(`input[name='${consentType}'].cookie-switch-input`);
            
            // Load saved state from localStorage
            const consentState = localStorage.getItem(`${consentType.toLowerCase()}Consent`);
            if (consentState !== null) {
                if (consentState === "true") {
                    $switchInput.prop("checked", true);
                    $switchInput.closest('.switch').addClass('on');
                } else {
                    $switchInput.prop("checked", false);
                }
            }
        
            // Save state on change
            $switchInput.on("change", function () {
                localStorage.setItem(`${consentType.toLowerCase()}Consent`, $(this).prop("checked"));
                $switchInput.closest('.switch').toggleClass('on');
            });
        }
        
        handleConsentSwitch('ANALYTICS');
        handleConsentSwitch('ADVERTISING');
    }

    function updateGtagConsent(consentType) {
        const consentSettings = {
            'granted': {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'analytics_storage': 'granted'
            },
            'denied': {
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied',
                'analytics_storage': 'denied'
            }
        };
        
        if (typeof gtag === "function" && consentSettings[consentType]) {
            gtag('consent', consentType === 'granted' ? 'update' : 'default', consentSettings[consentType]);
        }
    }
    
    function loadConsent() {
        if (typeof gtag !== "function") return;
        
        const analyticsConsent = localStorage.getItem('analyticsConsent');
        
        if (analyticsConsent !== "true") {
            updateGtagConsent('denied');
        } else {
            updateGtagConsent('granted');
        }
        
        if (analyticsConsent === null) {
            $('#cookieBanner').show();
        }
        
        $(".cookie_options .allow-button").on("click", function () {
            localStorage.setItem('advertisingConsent', true);
            localStorage.setItem('analyticsConsent', true);
            updateGtagConsent('granted');
            $('#cookieBanner').hide();
        });
    }

    loadConsent();
});